import { locationKioskSettingViewDTOSchema, organizationKioskSettingDTOSchema, } from '@instanexus/contracts';
import { z } from 'zod';
import { dataEnvelopeSchema, WEB_API_PREFIX } from '../transport.js';
const KIOSK_SETTINGS_PATH = `${WEB_API_PREFIX}/kiosk-settings`;
const organizationSchema = dataEnvelopeSchema(organizationKioskSettingDTOSchema);
const locationViewSchema = dataEnvelopeSchema(locationKioskSettingViewDTOSchema);
function overridePath(locationId) {
    return `${WEB_API_PREFIX}/locations/${encodeURIComponent(locationId)}/kiosk-settings/override`;
}
export function createKioskSettingsResource(transport) {
    return {
        async get() {
            const envelope = await transport.request({ path: KIOSK_SETTINGS_PATH, schema: organizationSchema });
            return envelope.data;
        },
        async update(input) {
            const envelope = await transport.request({
                method: 'PATCH',
                path: KIOSK_SETTINGS_PATH,
                schema: organizationSchema,
                body: input,
            });
            return envelope.data;
        },
        async createLocationOverride(locationId) {
            const envelope = await transport.request({ method: 'PUT', path: overridePath(locationId), schema: locationViewSchema });
            return envelope.data;
        },
        async removeLocationOverride(locationId) {
            await transport.request({ method: 'DELETE', path: overridePath(locationId), schema: z.undefined() });
        },
    };
}
//# sourceMappingURL=kiosk-settings.js.map